import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React from 'react';

import DistributionFor from './DistributionFor';
import DistributionTable from './DistributionTable';
import {
  DISTRIBUTION_FOR_WITH_TABLE,
  DISTRIBUTION_TYPE_ADMIN_ROLE,
} from '../../constants/SmartInsightConstants';
import Rights from '../../saved-search-designer/controls/Rights';

const useStyles = makeStyles({
  mainContainer: {
    padding: '0px 32px 20px',
  },
});

const DistributionTab = ({
  isRightsShown,
  distributionForValueStore,
  onChangeDistributionValue,
  distributionListRows,
  handleAddNewDistributionRow,
  handleDeleteDistributionRow,
  handleZoomSelectDistributionList,
  validateDistribution,
  fullWidth = false,
  isAdmin = false,
}) => {
  const classes = useStyles();

  const isDistributionTableShown = isAdmin
    ? distributionForValueStore === DISTRIBUTION_TYPE_ADMIN_ROLE
    : DISTRIBUTION_FOR_WITH_TABLE.includes(distributionForValueStore);

  return (
    <Grid container flexDirection="column" className={fullWidth ? null : classes.mainContainer}>
      {isRightsShown && (
        <Grid item xs={12} lg={5}>
          <Rights prop="viewRights" />
        </Grid>
      )}
      <Grid item xs={12} lg={5}>
        <DistributionFor
          distributionForValueStore={distributionForValueStore}
          onChangeDistributionValue={onChangeDistributionValue}
          isAdmin={isAdmin}
        />
      </Grid>
      {isDistributionTableShown && (
        <Grid item xs={12} md={fullWidth ? 12 : 8}>
          <DistributionTable
            distributionForValueStore={distributionForValueStore}
            distributionListRows={distributionListRows}
            handleAddNewDistributionRow={handleAddNewDistributionRow}
            handleDeleteDistributionRow={handleDeleteDistributionRow}
            handleZoomSelectDistributionList={handleZoomSelectDistributionList}
            validateDistribution={validateDistribution}
            isAdmin={isAdmin}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default DistributionTab;
